import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyNames } from '@webapp/core/entities/external/Currency'
import { CardholderAccountStatuses } from '@webapp/modules/spending-cards/entities/enums/CardholderAccountStatusEnum'
import { CardStatuses } from '@webapp/modules/spending-cards/entities/enums/CardStatusEnum'
import { CardTypes } from '@webapp/modules/spending-cards/entities/enums/CardTypeEnum'
import { IssuingProviders } from '@webapp/modules/spending-cards/entities/enums/IssuingProvider'
import {
  type CardCardholderApiModel,
  type DetailedCardApiModel,
} from '../DetailedCardApiModel'

export const DetailedCardApiModelStub =
  Factory.Sync.makeFactory<DetailedCardApiModel>({
    id: Factory.each(() => faker.random.number()),
    external_id: Factory.each(() => faker.random.uuid()),
    number: Factory.each(() => faker.random.number().toString()),
    category: CardTypes.PHYSICAL,
    status: Factory.each(() => CardStatuses.ACTIVE),
    created_at: Factory.each(() => faker.date.past().toISOString()),
    updated_at: Factory.each(() => faker.date.past().toISOString()),
    require_activation: false,
    balance: Factory.each(() => faker.random.number().toString()),
    currency: CurrencyNames.USD,
    cardholder: Factory.each<CardCardholderApiModel>(() => ({
      id: faker.random.number(),
      external_id: faker.random.uuid(),
      user_id: faker.random.number(),
      first_name: faker.name.firstName(),
      last_name: faker.name.lastName(),
      profile_image: faker.image.avatar(),
      email: faker.internet.email(),
      department_id: faker.random.number(),
      tos_accepted: true,
      status: CardholderAccountStatuses.ACTIVE,
      provider: IssuingProviders.AIRWALLEX,
      billing_address: {
        name: faker.name.firstName(),
        address_line_one: faker.address.streetAddress(),
        address_line_two: null,
        postal_code: faker.address.zipCode(),
        city: faker.address.city(),
        state_province: faker.address.state(),
        country: faker.address.country(),
      },
    })),
    shipping_address: {
      name: faker.name.firstName(),
      address_line_one: faker.address.streetAddress(),
      address_line_two: null,
      postal_code: faker.address.zipCode(),
      city: faker.address.city(),
      state_province: faker.address.state(),
      country: faker.address.country(),
    },
  })
